export default class RequestError extends Error {
  constructor(message?: string) {
    super(`Request error:: ${message}`);
    this.name = 'RequestError';
  }
}
